<div class="spinner-wrapper" *ngIf="showLoader">
  <mat-spinner></mat-spinner>
</div>
<div class="container equipment-wrapper">
  <h2>Confirm</h2>
  <hr />
  <div class="breadcrumb">
    <ul class="d-flex align-items-center breadcrumb__list">
      <li class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link" [routerLink]="['/home']">Home</a>
      </li>
      <li class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link" [routerLink]="['/home']">Select Location</a>
      </li>
      <li class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link" [routerLink]="['/locations-select-designs']" [queryParams]="{ id: location?.location_id }">Select Design</a>
      </li>
      <li class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link">Confirm</a>
      </li>
    </ul>
  </div>
  <div class="d-flex flex-wrap row">
    <div class="col-md-6 col-12  px-3">
      <div class="equipment-wrapper__item p-3">
    <h2 class="equipment-wrapper__item__title">
    Name:  {{ location?.subdivision_name }}
    </h2>
    <p class="equipment-wrapper__item__detail">
      ID: {{ location?.location_id }}<br />
    </p>
    <p class="equipment-wrapper__item__detail">
      Lot: {{ location?.lot }}<br />
    </p>
    <p class="equipment-wrapper__item__detail">
      Street: {{ location?.street_address }}<br />
    </p>
    <p class="equipment-wrapper__item__detail">
      City: {{ location?.city }}<br />
    </p>
    <button mat-flat-button color="accent">
      Select Other Location
    </button>
  </div>
    </div>
    <div class="col-md-6 col-12 px-3">
      <div class="equipment-wrapper__item p-3">
    <h2 class="equipment-wrapper__item__title">
     Name: {{ systemsDesigns?.hvac_dsn_descrpt }}
    </h2>
    <p class="equipment-wrapper__item__detail">
      ID: {{ systemsDesigns?.hvac_design_id }}<br />
    </p>
    <button mat-flat-button color="accent" [routerLink]="['/locations-select-designs']" [queryParams]="{ id: location?.location_id }">
      Select Other Design
    </button>
  </div>
    </div>
  </div>

  <button mat-flat-button class="mt-3 me-3 select-location me-3" color="primary">
    CONFIRM
  </button>

  
</div>